import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { BigNumber } from "shared/cubiq-model-multi-asset";
import { AnyCnameRecord } from "dns";
import { BfxInputControlStateEnum } from "src/app/bfx-interface-controls/models/bfx-interface-controls.enums";
import { OEGammaLegType } from "../enums/oe-gamma-leg-type";
import { OEPanelGammaViewModel } from "./oe-panel-gamma-view.model";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

export class OEPanelGammaLeg {
  public aboveLeg: OEPanelGammaLeg;
  public belowLeg: OEPanelGammaLeg;
  private _amount: BigNumber;
  private _delta: BigNumber = new BigNumber(0);
  private _minRate: BigNumber = new BigNumber(0);
  private _maxRate: BigNumber = new BigNumber(0);
  public rate: BigNumber;

  //rate above for above mid, rate below for below mid
  public thresholdRate: BigNumber = new BigNumber(500000);
  public thresholdDelta: BigNumber = new BigNumber(500000);
  public minDelta: BigNumber = new BigNumber(2);

  private _fixedCcy: AnyCnameRecord;
  private _orderID: Number;
  private _errorString: String;
  private _ccyPair: any;
  private _extRef: String;
  private _legType: OEGammaLegType;
  private _direction: CubiqTS.OrderIntent;

  public hasError: boolean;
  public externalState: BfxInputControlStateEnum = BfxInputControlStateEnum.VALID;
  public borderColor: string = "#677489";
  public buyXLabel: string = "Buy";
  public sellXLabel: string = "Sell";
  public pipsXLabel: string = "Pips";
  public legId: number;
  public isCustomiseEnabled: Boolean;
  public viewerModel: OEPanelGammaViewModel;

  public get amount(): BigNumber {
    return this._amount;
  }
  public set amount(value: BigNumber) {
    this._amount = value;
  }

  public get delta(): BigNumber {
    return this._delta;
  }
  public set delta(value: BigNumber) {
    this._delta = value;
  }

  public activeDelta(): BigNumber {
    if (this.viewerModel.edit) {
      return this.thresholdDelta;
    } else {
      return this.delta;
    }
  }

  public get minRate(): BigNumber {
    return this._minRate;
  }
  public set minRate(value: BigNumber) {
    this._minRate = value;
  }

  public get maxRate(): BigNumber {
    return this._maxRate;
  }
  public set maxRate(value: BigNumber) {
    this._maxRate = value;
  }

  public get ccyPair(): any {
    return this._ccyPair;
  }
  public set ccyPair(value: any) {
    this._ccyPair = value;
  }

  public get fixedCcy(): any {
    return this._fixedCcy;
  }
  public set fixedCcy(value: any) {
    this._fixedCcy = value;
  }

  public get errorString(): String {
    return this._errorString;
  }
  public set errorString(value: String) {
    this._errorString = value;
  }

  public get orderID(): Number {
    return this._orderID;
  }
  public set orderID(value: Number) {
    this._orderID = value;
  }

  public get extRef(): String {
    return this._extRef;
  }
  public set extRef(value: String) {
    this._extRef = value;
  }

  public get legType(): OEGammaLegType {
    return this._legType;
  }
  public set legType(value: OEGammaLegType) {
    this._legType = value;
  }

  public get direction(): CubiqTS.OrderIntent {
    return this._direction;
  }
  public set direction(value: CubiqTS.OrderIntent) {
    this._direction = value;
  }

  public get directionLabel(): string {
    let ret: string =
      this._direction != null && this._direction == 0 ? this.buyXLabel : this.sellXLabel;
    return ret;
  }

  public get deltaLabel(): string {
    let ret: string =
      this.delta === null ? "0 " + this.pipsXLabel : this.delta.toString() + " " + this.pipsXLabel;
    return ret;
  }

  public cloneGammaLeg(): OEPanelGammaLeg {
    let clone: OEPanelGammaLeg = new OEPanelGammaLeg();
    clone.aboveLeg = this.aboveLeg;
    clone.activeDelta = this.activeDelta;
    clone.amount = this.amount;
    clone.belowLeg = this.belowLeg;
    clone.borderColor = this.borderColor;
    clone.buyXLabel = this.buyXLabel;
    clone.ccyPair = this.ccyPair;
    clone.delta = this.delta;
    clone.direction = this.direction;
    clone.errorString = this.errorString;
    clone.extRef = this.extRef;
    clone.externalState = this.externalState;
    clone.fixedCcy = this.fixedCcy;
    clone.hasError = this.hasError;
    clone.isCustomiseEnabled = this.isCustomiseEnabled;
    clone.legId = this.legId;
    clone.legType = this.legType;
    clone.maxRate = this.maxRate;
    clone.minDelta = this.minDelta;
    clone.minRate = this.minRate;
    clone.orderID = this.orderID;
    clone.pipsXLabel = this.pipsXLabel;
    clone.rate = this.rate;
    clone.sellXLabel = this.sellXLabel;
    clone.thresholdDelta = this.thresholdDelta;
    clone.thresholdRate = this.thresholdRate;
    clone.viewerModel = this.viewerModel;
    return clone;
  }
}
